module.exports = __webpack_public_path__ + "static/media/dashboard.714d85a7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/dashboard.svg
// module id = 512
// module chunks = 49